import { render, staticRenderFns } from "./RsaFatturazioneDettaglioListPage.vue?vue&type=template&id=9c953e3c"
import script from "./RsaFatturazioneDettaglioListPage.vue?vue&type=script&lang=js"
export * from "./RsaFatturazioneDettaglioListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports